import type {
	API_GetDashboardResponse,
	DashboardData,
} from "@pilatestime-admin/shared-types";
import { queryOptions } from "@tanstack/react-query";
import api from "./api_client";

/**
 * Fetch dashboard data from the API
 */
export const fetchDashboard = (token: string): Promise<DashboardData> =>
	api
		.get<API_GetDashboardResponse>("/dashboard", {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
		.then((res) => res.data.data);

/**
 * Query options for fetching dashboard data
 */
export const fetchDashboardQueryOptions = (token: string) =>
	queryOptions({
		queryKey: ["dashboard"],
		queryFn: () => fetchDashboard(token),
		staleTime: 1 * 60 * 1000, // 1 minute
		refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
	});
